import { ApplicationLogoNoIcon } from "bonza-shared"
import { Link, router } from "@inertiajs/react"
import MarketingSignupInput from "@/components/molecules/MarketingSignupInput/MarketingSignupInput"
import FacebookLogo from "bonza-shared/js/components/icons/socials/facebook"
import SocialIconButton from "bonza-shared/js/components/atoms/SocialIconButton/SocialIconButton"
import InstagramLogo from "bonza-shared/js/components/icons/socials/instagram"
import TwitterXLogo from "bonza-shared/js/components/icons/socials/twitter"
import LinkedInLogo from "bonza-shared/js/components/icons/socials/linkedIn"
import TikTokLogo from "bonza-shared/js/components/icons/socials/tiktok"
import YoutubeLogo from "bonza-shared/js/components/icons/socials/youtube"
import { useLogger, User } from "bonza-shared/js"
import { Button } from "@headlessui/react"

export default function Footer({ user }: { user?: User }) {
    const logger = useLogger("Footer")
    const logoutCallback = () => {
        router.post(route("logout"), undefined, {
            onFinish: () => router.visit(route("web.home")),
            onError: (err) => logger.error(err),
        })
    }
    const columnOneRoutes = [
        { route: "web.home", text: "Home" },
        { route: "web.artists", text: "Artists" },
        { route: "web.studios", text: "Studios" },
        { route: "web.teachers", text: "Private Teachers" },
        { route: "web.education", text: "Education" },
        { route: "web.plans", text: "Plans" },
    ]

    const userRoutes = user
        ? [
              { callback: logoutCallback, text: "Sign out" },
              // { route: "web.home", text: "Account (missing link!)" },
          ]
        : [
              { route: "web.plans", text: "Try for free" },
              { route: "web.login", text: "Sign in" },
          ]

    const columnTwoRoutes = [
        ...userRoutes,
        { link: "mailto:support@bonzamusic.com", text: "Support" },
        { route: "web.partner", text: "Partner with Bonza" },
        // { link: "mailto:press@bonzamusic.com", text: "Contact press" },
        {
            route: "web.legal",
            text: "Terms and conditions",
            params: { tandc: 1 },
        },
    ]

    return (
        <footer
            className={`
                grid justify-between gap-8 p-8 pt-16

                md:grid-cols-2
            `}
        >
            <div className={"flex flex-col gap-12"}>
                <div className={"flex flex-col gap-4"}>
                    <p className={"text-lg"}>
                        Subscribe to our newsletter for updates.
                    </p>
                    <MarketingSignupInput />
                </div>
                <div className={"flex flex-col gap-4"}>
                    <h6 className={"text-xl"}>Connect</h6>
                    <ul className={"flex flex-wrap gap-2"}>
                        <li>
                            <SocialIconButton
                                href={"https://www.instagram.com/bonzamusic"}
                                ariaLabel={"Instagram"}
                            >
                                <InstagramLogo
                                    className={`
                                        size-5

                                        sm:size-6
                                    `}
                                />
                            </SocialIconButton>
                        </li>
                        <li>
                            <SocialIconButton
                                href={"https://x.com/bonzamusiclive"}
                                ariaLabel={"X"}
                            >
                                <TwitterXLogo
                                    className={`
                                        size-5

                                        sm:size-6
                                    `}
                                />
                            </SocialIconButton>
                        </li>
                        <li>
                            <SocialIconButton
                                href={
                                    "https://www.facebook.com/share/1F6PEUDqPq/?mibextid=wwXIfr"
                                }
                                ariaLabel={"Facebook"}
                            >
                                <FacebookLogo
                                    className={`
                                        size-5

                                        sm:size-6
                                    `}
                                />
                            </SocialIconButton>
                        </li>
                        <li>
                            <SocialIconButton
                                href={
                                    "https://www.linkedin.com/company/bonzamusic/"
                                }
                                ariaLabel={"LinkedIn"}
                            >
                                <LinkedInLogo
                                    className={`
                                        size-5

                                        sm:size-6
                                    `}
                                />
                            </SocialIconButton>
                        </li>
                        <li>
                            <SocialIconButton
                                href={"https://www.tiktok.com/@bonzamusiclive"}
                                ariaLabel={"Tiktok"}
                            >
                                <TikTokLogo
                                    className={`
                                        size-5

                                        sm:size-6
                                    `}
                                />
                            </SocialIconButton>
                        </li>
                        <li>
                            <SocialIconButton
                                href={"https://www.youtube.com/@Bonza-Music"}
                                ariaLabel={"Youtube"}
                            >
                                <YoutubeLogo
                                    className={`
                                        size-5

                                        sm:size-6
                                    `}
                                />
                            </SocialIconButton>
                        </li>
                    </ul>
                </div>
            </div>
            <div className={""}>
                <div
                    className={`
                        ml-auto grid grid-cols-2 gap-8

                        md:max-w-[400px]
                    `}
                >
                    <LinkColumn links={columnOneRoutes} />
                    <LinkColumn links={columnTwoRoutes} />
                </div>
            </div>
            <div className={"col-span-full grid w-full gap-4 p-2 md:pt-12"}>
                <div
                    className={`flex w-full flex-col items-center justify-end`}
                >
                    <ApplicationLogoNoIcon className={"w-full"} />
                </div>
                <span className={"text-bonza-pale-t-60"}>
                    ©Bonza Music All Rights Reserved 2026.
                </span>
            </div>
        </footer>
    )
}

const LinkColumn = ({
    links,
}: {
    links: {
        route?: string
        link?: string
        callback?: () => void
        text: string
        params?: object
    }[]
}) => {
    return (
        <ul className={"flex flex-col gap-4"}>
            {links.map((item, index) => {
                if (!item.route && !item.link && !item.callback) return
                return (
                    <li key={index}>
                        {item.route && (
                            <Link
                                href={route(item.route, item.params)}
                                className={`
                                    border-b border-transparent pb-0.5
                                    transition-colors

                                    hover:border-bonza-pale
                                `}
                            >
                                {item.text}
                            </Link>
                        )}
                        {item.link && (
                            <a
                                href={item.link}
                                className={`
                                    border-b border-transparent pb-0.5
                                    transition-colors

                                    hover:border-bonza-pale
                                `}
                            >
                                {item.text}
                            </a>
                        )}
                        {item.callback && (
                            <Button onClick={item.callback}>{item.text}</Button>
                        )}
                    </li>
                )
            })}
        </ul>
    )
}
